import { Coffee, MapPin, Clock, ArrowUpRight } from "lucide-react";

// sons — Hackney Coffee · Editorial Warm
export default function SonsAfter({ b }) {
  return (
    <div className="bg-[#FDFBF7] text-[#3D291F]">
      {/* Top bar */}
      <div className="border-b border-[#3D291F]/10 px-6 md:px-10 py-4 flex items-center justify-between text-xs">
        <div className="font-cormorant italic text-2xl">sons.</div>
        <nav className="hidden md:flex items-center gap-6 font-spacemono uppercase tracking-[0.2em] text-[10px]">
          <span>Menu</span><span>Bakery</span><span>Wholesale</span><span>Visit</span>
        </nav>
        <button className="bg-[#3D291F] text-[#FDFBF7] px-4 py-2 font-spacemono uppercase tracking-[0.2em] text-[10px] hover:bg-[#A97C50]">
          Order ahead
        </button>
      </div>

      {/* Hero */}
      <div className="grid grid-cols-1 md:grid-cols-12 px-6 md:px-10 py-16 md:py-24 gap-10">
        <div className="md:col-span-7">
          <p className="font-spacemono uppercase tracking-[0.3em] text-[10px] text-[#A97C50] mb-6">EST. ON LOWER CLAPTON RD · E5</p>
          <h1 className="font-cormorant italic text-6xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight">
            A small room. <br/>
            A slow pour. <br/>
            <span className="not-italic font-normal text-[#A97C50]">A neighbourhood</span>
            <span className="italic"> habit.</span>
          </h1>
          <p className="mt-8 max-w-lg text-lg leading-relaxed text-[#3D291F]/80 font-light">
            sons opens at 7am inside the courtyard of St John at Hackney. Single-origin espresso pulled on a vintage La Marzocco,
            sourdough laminated by hand, and the kind of quiet that makes you cancel your morning plans.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <a className="bg-[#3D291F] text-[#FDFBF7] px-6 py-3 font-spacemono uppercase tracking-[0.2em] text-[10px] hover:bg-[#A97C50] transition-colors">See today's bake</a>
            <a className="border border-[#3D291F] text-[#3D291F] px-6 py-3 font-spacemono uppercase tracking-[0.2em] text-[10px]">Find us</a>
          </div>
        </div>
        <div className="md:col-span-5">
          <div
            className="aspect-[4/5] bg-cover bg-center"
            style={{ backgroundImage: "url(https://images.pexels.com/photos/15898642/pexels-photo-15898642.jpeg)" }}
          />
          <div className="grid grid-cols-3 mt-3 gap-1 text-center font-spacemono text-[10px] uppercase tracking-[0.2em]">
            <div className="bg-[#3D291F] text-[#FDFBF7] py-2">Open · 7–4</div>
            <div className="border border-[#3D291F]/30 py-2">{b.rating}★</div>
            <div className="border border-[#3D291F]/30 py-2">{b.reviews} reviews</div>
          </div>
        </div>
      </div>

      {/* Menu strip */}
      <div className="border-y border-[#3D291F]/15 bg-[#F4EFE5] px-6 md:px-10 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            ["Flat white", "£3.40"],
            ["Cortado", "£3.10"],
            ["Cardamom bun", "£4.20"],
            ["Sourdough toast", "£5.50"],
          ].map(([k, v]) => (
            <div key={k} className="flex items-baseline justify-between border-b border-dashed border-[#3D291F]/30 pb-3">
              <span className="font-cormorant italic text-2xl">{k}</span>
              <span className="font-spacemono text-sm">{v}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Visit */}
      <div className="px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-2 gap-12">
        <div>
          <h2 className="font-cormorant italic text-5xl mb-6">Find us in the courtyard.</h2>
          <div className="space-y-3 text-sm">
            <p className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[#A97C50]" /> {b.address}</p>
            <p className="flex items-center gap-2"><Clock className="w-4 h-4 text-[#A97C50]" /> Mon–Fri 7–16 · Sat–Sun 8–17</p>
            <p className="flex items-center gap-2"><Coffee className="w-4 h-4 text-[#A97C50]" /> Beans by Caravan, Round Hill, La Cabra</p>
          </div>
        </div>
        <div className="bg-[#3D291F] text-[#FDFBF7] p-8">
          <p className="font-spacemono uppercase tracking-[0.3em] text-[10px] text-[#A97C50] mb-4">Wholesale enquiries</p>
          <h3 className="font-cormorant italic text-3xl mb-4">Pour our beans in your office.</h3>
          <p className="text-[#FDFBF7]/70 text-sm leading-relaxed mb-6">10kg minimum · Free delivery within E2/E5/E8 · Free machine setup.</p>
          <button className="bg-[#A97C50] text-[#FDFBF7] px-6 py-3 font-spacemono uppercase tracking-[0.2em] text-[10px] flex items-center gap-2">
            Enquire <ArrowUpRight className="w-3 h-3" />
          </button>
        </div>
      </div>
    </div>
  );
}
